export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '会员ID', dataIndex: 'id', width: 200},
    {title: '会员昵称', dataIndex: 'name',width: 120, ellipsis: true},
    {title: '手机号码', dataIndex: 'phone', width: 200, ellipsis: true},
    {title: '等级', dataIndex: 'levelName', width: 200, ellipsis: true},
    {title: '积分', dataIndex: 'integralValue', width: 200, },
    {title: '成长值', dataIndex: 'growValue', width: 200, },
    {title: '入会时间', dataIndex: 'createdTime', width: 200, itemType: 'dateTime'},
    {title: '操作', dataIndex: 'action', width: 300, fixed: 'right', render: 'actionRender'},
  ],
  footer: [
    {label: '导出', type: 'primary', events: ['onClick:onExport']}
  ],
  search: [
    { label: '会员昵称', name: 'name' },
    { label: '手机号码', name: 'phone' },
    { label: '等级', name: 'levelType',itemType: 'select', data:'levelList', key:'type',labelKey: 'name', },
  ]
}

export const configIntegral = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '流水号', dataIndex: 'id', width: 200},
    {title: '积分事件', dataIndex: 'memberEventName', width: 100, ellipsis: true},
    {title: '积分值', dataIndex: 'value', width: 100, ellipsis: true},
    {title: '当前积分值', dataIndex: 'currentValue', width: 100, ellipsis: true},
    {title: '备注', dataIndex: 'description', width: 200, ellipsis: true},
    {title: '流水时间', dataIndex: 'createdTime', width: 200, itemType: 'dateTime'},
  ],
  footer: [
    {label: '导出', type: 'primary', events: ['onClick:onExport']}
  ]
}

export const configGrowth = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '流水号', dataIndex: 'id', width: 200},
    {title: '成长值事件', dataIndex: 'memberEventName', width: 130, ellipsis: true},
    {title: '成长值', dataIndex: 'value', width: 100, ellipsis: true},
    {title: '当前成长值', dataIndex: 'currentValue', width: 130, ellipsis: true},
    {title: '等级', dataIndex: 'levelName', width: 100, ellipsis: true},
    {title: '备注', dataIndex: 'description', width: 200, ellipsis: true},
    {title: '流水时间', dataIndex: 'createdTime', width: 200, itemType: 'dateTime'},
  ],
  footer: [
    {label: '导出', type: 'primary', events: ['onClick:onAdd']}
  ]
}
